export default __webpack_public_path__ + "static/media/Q7-3.45af692f.jpg";